import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {DietaryIndicatorEntityModel} from "../dietary-indicator-entity.model";

@Component({
    selector: "wbo-dietary-indicator-edit-page",
    templateUrl: "./dietary-indicator-edit-page.component.html",
    providers: [provideEntityModel(DietaryIndicatorEntityModel)]
})
export class DietaryIndicatorEditPageComponent extends AbstractEditPage {
    constructor(public model: DietaryIndicatorEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
